// ----------------------------------------------------
// src/Redux/Slices/HeroSlice.js
// ----------------------------------------------------

import { createSlice } from "@reduxjs/toolkit";
import HeroData from "../../Json/HeroData.json";

const HeroSlice = createSlice({
  name: "hero",
  initialState: HeroData,
  reducers: {},
});

export default HeroSlice.reducer;